import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { Link } from 'react-router-dom';

function ServiceThree() {
    return (
        <div>
            {/* rts-service area start */}
            <div className="rts-service-area rts-section-gap pb--140">
                <div className="container">
                    
                    <div className="row g-5 mt--20">
                        <div className="col-12">
                            <div className="swiper ">
                                <Swiper
                                    // install Swiper modules
                                    modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                                    className="mySwiperh2_Service"
                                    speed={200}
                                    slidesPerView={3}
                                    spaceBetween={30}
                                    loop={true}
                                    autoplay={true}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                    breakpoints={{
                                        1200: { slidesPerView: 3 },
                                        900: { slidesPerView: 3 },
                                        768: { slidesPerView: 2 },
                                        580: { slidesPerView: 2 },
                                        450: { slidesPerView: 1 },
                                        0: { slidesPerView: 1 },
                                    }}
                                >
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/canalizare.jpg`}
                                                        alt="Sisteme de canalizare"
                                                    />
                                                </Link>
                                                <div className="content">

                                                    <h5 className="title">Sisteme de Canalizare</h5>
                                                    <p className="disc">
                                                        Proiectare și instalare sisteme de canalizare moderne pentru diverse tipuri de clădiri
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            <Link
                                                href="service-details.html"
                                                className="rts-btn btn-primary-3"
                                            >
                                                {" "}
                                                Citește Mai Mult
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/epurare.jpg`}
                                                        alt="Stații de Epurare"
                                                    />
                                                </Link>
                                                <div className="content">

                                                    <h5 className="title">Stații de Epurare</h5>
                                                    <p className="disc">
                                                        Construcția și întreținerea stațiilor de epurare pentru tratarea apelor uzate
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            <Link
                                                href="service-details.html"
                                                className="rts-btn btn-primary-3"
                                            >
                                                {" "}
                                                Citește Mai Mult
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/apeduct.jpg`}
                                                        alt="Apeducte și Stații de Pompare"
                                                    />
                                                </Link>
                                                <div className="content">

                                                    <h5 className="title">Apeducte și Stații de Pompare</h5>
                                                    <p className="disc">
                                                        Instalarea și mentenanța rețelelor de apă potabilă și stațiilor de pompare
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/casangerie.jpg`}
                                                        alt="Casangerii"
                                                    />
                                                </Link>
                                                <div className="content">

                                                    <h5 className="title">Casangerii</h5>
                                                    <p className="disc">
                                                        Servicii profesionale de casangerii pentru înlocuirea și repararea conductelor
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            <Link
                                                href="service-details.html"
                                                className="rts-btn btn-primary-3"
                                            >
                                                {" "}
                                                Citește Mai Mult
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/mententanta.jpg`}
                                                        alt="Servicii de Mentenanță"
                                                    />
                                                </Link>
                                                <div className="content">
    
                                                    <h5 className="title">Servicii de Mentenanță</h5>
                                                    <p className="disc">
                                                        Servicii complete de mentenanță și reparații pentru sisteme de apă și canalizare
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            <Link
                                                href="service-details.html"
                                                className="rts-btn btn-primary-3"
                                            >
                                                {" "}
                                                Citește Mai Mult
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service-details'} className="thumbnail">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images_new/service/scada.jpg`}
                                                        alt="Sisteme de Automatizare Industriale"
                                                    />
                                                </Link>
                                                <div className="content">
    
                                                    <h5 className="title">Sisteme de Automatizare Industriale</h5>
                                                    <p className="disc">
                                                        Implementarea sistemelor de automatizare și control pentru procesele industriale
                                                    </p>
                                                </div>
                                                <Link href="service-details.html" className="over_link" />
                                            </div>
                                            <Link
                                                href="service-details.html"
                                                className="rts-btn btn-primary-3"
                                            >
                                                {" "}
                                                Citește Mai Mult
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            {/* rts-service area end */}
        </div>
    )
}

export default ServiceThree